import React, { useState, useEffect } from "react";
import {
  Chip,
  SearchInput,
  INPUT_SIZES,
  PrimaryButton,
  IconOrder,
} from "cdk-radial";
import "../api-directory.css";
import { API_DIRECTORY_THEME } from "../../../../utils/constants";
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from "../../../../utils/AmplitudeConstants";

function SearchResult({
  count,
  selectedAPIType,
  selectedDomainIds,
  selectedOrgs,
  setSearchFilters,
  searchText,
  domains,
  setSearchText,
  cartDetails,
  belongsTo,
  apiHomeOnClickHandlers,
  sendAmplitudeData,
  selectedFilterType,
  isMsaConsented
}) {
  const [apiType, setApiTye] = useState([]);
  const [category, setCategory] = useState([]);
  const [org, setOrg] = useState([]);
  const [filterType, setFilterType]=useState([]);
 
const API_TYPE_MAPPING = {
  "REST": "restApi",
  "Async": "asyncApi"
};

const urlParams = new URLSearchParams(window.location.search);
const handleAPIClose = (e) => {
  sendAmplitudeData(AMPLITUDE_EVENTS.REMOVE_APIS, {
      [AMPLITUDE_PROPERTIES.REMOVE_API]: {
          [AMPLITUDE_PROPERTIES.REMOVE_API]: e || '',
      }
  });

  const mappedValue = API_TYPE_MAPPING[e] || e;

    const newArray = apiType.filter((m) => m !== e);
    setApiTye(newArray);
    setSearchFilters(
      {
        apiType: newArray,
        category,
        org,
        filterType
      },
      "searchText"
  );
  if(belongsTo === API_DIRECTORY_THEME.ISV_API_DIRECTORY){

  let existingAPIs = urlParams.get("Type"); 

  if (existingAPIs) {
      let apiList = existingAPIs.split(",").map(decodeURIComponent);
      apiList = apiList.map(item => Object.values(API_TYPE_MAPPING).includes(item) ? item : item);

    
      apiList = apiList.filter(item => item !== mappedValue);
      if (apiList.length > 0) {
          urlParams.set("Type", apiList.map(encodeURIComponent).join(",")); 
      } else {
          urlParams.delete("Type"); 
      }
  }
    sessionStorage.setItem("selectedFilters", urlParams.toString());
  const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
  apiHomeOnClickHandlers.handleUrlparams({
    newUrl
   })
  }else{
     apiHomeOnClickHandlers?.handleClearDealerFilters({apiType:newArray,category,org,filterType})
  }
};


  const handleCategoryClose = (e) => {
    sendAmplitudeData(AMPLITUDE_EVENTS.REMOVE_CATEGORY, {
      [AMPLITUDE_PROPERTIES.REMOVE_CATEGORY] : {
        [AMPLITUDE_PROPERTIES.REMOVE_CATEGORY] : e || '',
    }
    });
    const newArray = category.filter((m) => m !== e);
    setCategory(newArray);
    setSearchFilters(
      {
        apiType,
        category: newArray,
        org,
        filterType
      },
      "searchText"
    );
    if(belongsTo === API_DIRECTORY_THEME.ISV_API_DIRECTORY){
      let existingCategories = urlParams.get("Category");
  
      if (existingCategories) {
        let categoryList = existingCategories.split(",");
        categoryList = categoryList.filter(item => decodeURIComponent(item) !== e);
    
        if (categoryList.length > 0) {
          urlParams.set("Category", categoryList.join(",")); 
        } else {
          urlParams.delete("Category"); 
        }
      }
      sessionStorage.setItem("selectedFilters", urlParams.toString());
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      apiHomeOnClickHandlers.handleUrlparams({
       newUrl
      })
    }
    else{
        apiHomeOnClickHandlers?.handleClearDealerFilters({apiType,category:newArray,org,filterType})
    }
  };
  

  const handleOrgClose = (e) => {
    const newArray = org.filter((m) => m !== e);
    setOrg(newArray);
    setSearchFilters(
      {
        apiType,
        category,
        org: newArray,
        filterType
      },
      "searchText"
    );
     if(belongsTo === API_DIRECTORY_THEME.DEALER_API_DIRECTORY){
         apiHomeOnClickHandlers?.handleClearDealerFilters({apiType,category,org:newArray,filterType}) 
     }
    };

  const handleFilterClose = (e) => {
    const newArray = filterType.filter((m) => m !== e);
    setFilterType(newArray);
    setSearchFilters(
      {
        apiType,
        category,
        org,
        filterType: newArray
      },
      "searchText"
    );
  
    if(belongsTo === API_DIRECTORY_THEME.ISV_API_DIRECTORY){
      let existingFilters = urlParams.get("Group"); 
      if (existingFilters) {
        let filterList = existingFilters.split(",").map(decodeURIComponent);
        filterList = filterList.filter(item => item !== e);
    
        if (filterList.length > 0) {
          urlParams.set("Group", filterList.map(encodeURIComponent).join(",")); 
        } else {
          urlParams.delete("Group"); 
        }
      }
      sessionStorage.setItem("selectedFilters", urlParams.toString());
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      apiHomeOnClickHandlers.handleUrlparams({
        newUrl
       })
    }
    else{
       apiHomeOnClickHandlers?.handleClearDealerFilters({apiType,category,org,filterType:newArray})
    }
  };
  

  const handleClearAll = () => {
    if(belongsTo === API_DIRECTORY_THEME.ISV_API_DIRECTORY){
      apiHomeOnClickHandlers.handleFiltersRedirection({
        apiType:[],
        category:[],
        org:[],
        filterType:[]
       });
       sessionStorage.removeItem("selectedFilters");
      apiHomeOnClickHandlers.handleUrlparams({
        newUrl: '/'
       })
    }
    if(belongsTo === API_DIRECTORY_THEME.DEALER_API_DIRECTORY){
      apiHomeOnClickHandlers.handleDealerFiltersRedirection({
      });
    } 
    sendAmplitudeData(AMPLITUDE_EVENTS.REMOVE_FILTER, {
      [AMPLITUDE_PROPERTIES.REMOVE_FILTER] : {
        [AMPLITUDE_PROPERTIES.REMOVE_API] : apiType || '',
        [AMPLITUDE_PROPERTIES.REMOVE_CATEGORY] : category || '',
    }
    });

    setApiTye([]);
    setOrg([]);
    setCategory([]);
    setFilterType([]);
    setSearchFilters(
      {
        apiType: [],
        category: [],
        org: [],
        filterType:[]
      },
      "searchText"
    );
  };

  // map chip label
  const chipLableMap = (e) => {
    const locCategories = (domains?.items ?? [0, 1])[1]?.dimensions || [];
    return locCategories.find((f) => f.id === e)?.name || "";
  };

  const chipOrgLableMap = (e) => {
    const locOrgs = (domains?.items ?? [])[0]?.dimensions || [];
    return locOrgs.find((f) => f.id === e)?.name || "";
  };

  useEffect(() => {
    setApiTye(selectedAPIType);
    setOrg(selectedOrgs);
    setCategory(selectedDomainIds);
    setFilterType(selectedFilterType);
  }, [selectedAPIType, selectedOrgs, selectedDomainIds, selectedFilterType]);

  return (
    <>
      <div className="api-dir-pkg_api-main-header api-dir-pkg_result_wrapper">
        <div className="api-dir-pkg_search-container">
          <span className="api-dir-pkg_search-results">
            {searchText !== "" && (
              <span>{`Results for ${searchText} (${count})`}</span>
            )}
            {searchText === "" && 
            (selectedAPIType.length || selectedDomainIds.length || selectedFilterType.length) > 0 && <span>{`Results (${count})`}</span>}
          </span>


          <div className="api-dir-pkg_search-input-container">
            <SearchInput
              dataTestId="search-input"
              clearButtonLabel="clearButtonLabel"
              id="search-input-expanded"
              isAlwaysExpanded
              name="search-input-expanded"
              onChange={setSearchText}
              value={searchText}
              size={INPUT_SIZES.STANDARD}
              placeholder="Search"
            />
          </div>

          {belongsTo === API_DIRECTORY_THEME.DEALER_API_DIRECTORY && (
            <PrimaryButton
              icon={<IconOrder />}
              text={`My Cart${cartDetails && cartDetails.length
                  ? ` (${cartDetails.length})`
                  : ""
                }`}
              onClick={() => {
                apiHomeOnClickHandlers.openMyCart();
              }}
              style={{}}
              isDisabled ={!isMsaConsented}
            />
          )}
        </div>

        <div className="api-dir-pkg_chip_container">
          {!!apiType &&
            Array.isArray(apiType) &&
            apiType.length > 0 &&
            apiType.map((e, idx) => {
              return (
                <Chip
                  key={idx}
                  className="api-dir-pkg_custom_chip"
                  label={e}
                  onRemove={() => handleAPIClose(e)}
                />
              );
            })}
          {!!category &&
            Array.isArray(category) &&
            category.length > 0 &&
            category.map((e, idx) => {
              return (
                <Chip
                  key={idx}
                  className="api-dir-pkg_custom_chip"
                  label={chipLableMap(e)}
                  onRemove={() => handleCategoryClose(e)}
                />
              );
            })}
          {!!org &&
            Array.isArray(org) &&
            org.length > 0 &&
            org.map((e, idx) => {
              return (
                <Chip
                  key={idx}
                  className="api-dir-pkg_custom_chip"
                  label={chipOrgLableMap(e)}
                  onRemove={() => handleOrgClose(e)}
                />
              );
            })}
          {!!filterType &&
            Array.isArray(filterType) &&
            filterType.length > 0 &&
            filterType.map((e, idx) => {
              return (
                <Chip
                  key={idx}
                  className="api-dir-pkg_custom_chip"
                  label={e}
                  onRemove={() => handleFilterClose(e)}
                />
              );
            })}  

          {(apiType?.length !== 0 ||
            category?.length !== 0 ||
            org?.length !== 0 ||
            filterType?.length !==0) && (
              <button
                className="api-dir-pkg_clear_all_button"
                onClick={handleClearAll}
              >
                Clear All
              </button>
            )}
        </div>
      </div>
      <div className="api-dir-pkg_result_gap"></div>
    </>
  );
}

export default SearchResult;
